export default __webpack_public_path__ + "static/media/awesome-location-arrow.2ed8b49b.svg";